import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>
        Made by{" "}
        <a href="https://davidpc.ca" target="_blank" rel="noreferrer">
          David Pavlove Cunsolo
        </a>
      </p>
      <p>
        <a href="/privacy">Privacy policy</a> · <a href="/support">Support</a>
      </p>
    </footer>
  );
}

export default Footer;
